export default "__VITE_ASSET__BdhE3HN2__"